import React, { useState, useEffect,useRef } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Password } from 'primereact/password'
import { Divider } from 'primereact/divider';
import { useHistory } from 'react-router-dom';
import { EMAIL_TYPE } from '../../../utils/constants';
import { AuthApiService } from '../../../services/AuthApiService';
import { Toast } from 'primereact/toast';
import {publishService} from './publishService';
import './MultiFactorAuth.css'
const MFAEmail = (props) => {
  const {
    emailExpand,
    emailIsEnabled,
    userId,
    userName,
    id,
    email,
    primaryEmail,
    mfaStatus,
    handleEmailExpand,
    updateDeviceDefault,
    deviceRemoved,
    updateSuccess,
    updateError
  } = props;

  const _apiService = new AuthApiService();

  const [newEmailAddress, setNewEmailAddress] = useState();
  const [acctPassword, setAccountPassword] = useState();
  const [message, setMessage] = useState('');
  const [otpCode,setOtpCode] = useState(null)
  const [showSubmit,setShowSubmit] = useState(false)
  const [deviceId,setDeviceId] = useState(null)
  const [requestId,setRequestId] = useState(null)
  const [showUpdateEmail,setShowUpdateEmail] = useState(false)
  const [invalidOtp,setInvalidOtp] = useState(false)
  const [invalidPassword,setInvalidPassword] = useState(false)
  const toast = useRef(null)
  const history = useHistory();

  const emailAddressRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  useEffect(() => {
    setNewEmailAddress('');
  }, [email]);

/*
  Enroll default email address from user profile. No need to pass any email address. 
  This would be case when user opts to register their default email address for MFA
  */
  const enrollDefaultEmail = async () => {
    const data = {
      schemas: ['urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorEnroller'],
      user: {
        value: userId
      },
      authnFactors: [EMAIL_TYPE],
    };

    const res = await _apiService.postEnrollMobile(data);

    if (!res || res.error) {
      console.error(res.error);
      updateError('Enroll email failed.');
    }
    else {
      // If success, navigate to verify-email page
      const {requestId, deviceId} = res;
      //TO-DO CHECK TO MAKE SURE verify is called properly
      history.push({
        pathname: '/auth/verify-email',
        state: {
          email: primaryEmail,
          deviceId,
          requestId,
          userName
        },
      });
    }
  };

  /*
  Update default email address in user profile. 
  This would be case when user opts to change their email address in profile. 
  This will trigger a verification email link to the new email address. 
  User would have to click the link in email to verify new email address. 
  Backend IDCS will automatically replace current email address with new one upon verification. 
  Device ID remains as is. MFA Enrollment and Default MFA status seem to carry over to new email address upon verification. 
  */

  const handleUpdateEmail = () => {
    setInvalidPassword(false)
    if (newEmailAddress !== '' && acctPassword !== '') {
      updateEmail(newEmailAddress, acctPassword);
    } else {
      setMessage('Required');
    }
  };

  /* Send update email request passing in current password and new email address */

  const updateEmail = async (newEmailAddress, acctPassword) => {

    //remove email verification if one exists
    const removeVerificationData = {
      schemas: ['urn:ietf:params:scim:schemas:oracle:idcs:MeRemovePendingEmailVerification'],
      "emailType": "primary"
      };
      const resRemoveVerificationData = await _apiService.removePendingEmailVerification(removeVerificationData);

      if (!resRemoveVerificationData || resRemoveVerificationData.error) {
        console.error(resRemoveVerificationData.error);
        updateError('Removing Email Verification Data Failed.');
      }


    //
    const data = {
      schemas: ['urn:ietf:params:scim:api:messages:2.0:PatchOp'],
      Operations: [
        {
          'op': 'replace',
          'path': 'urn:ietf:params:scim:schemas:oracle:idcs:extension:me:User:currentPassword',
          'value': acctPassword
        },
        {
          'op': 'replace', 'path': 'emails[type eq \"home\"]', 'value': [
            {'type': 'home', 'primary': true, 'value': newEmailAddress}
        ]
        }]
      };

    const res = await _apiService.patchUpdateEmail(data);

    if (!res || res.error) {
      try{
        updateError(res.errorData.response.data.detail);
        if(res.errorData.response.data.detail.indexOf("password")>-1&&res.errorData.response.data.detail.indexOf("invalid")>-1){
          setInvalidPassword(true)
        }
      }catch(err){
        updateError('Update email failed.');
      }
    }
    else {
      // If success, navigate to email update success page
      history.push({
        pathname: '/auth/verify-email', //'/auth/email-update-success',
        state: {
          email: newEmailAddress
        },
      });
    }
  };

  const enrollEmailWithoutOptCode = async () => {
   
    var emailConfirm;
    try{
      emailConfirm = await _apiService.requestEnrollEmailOtp(userId)
    }catch(err){
      toast.current.show({severity: 'error', summary: 'Enroll email error', detail: 'Failed to enroll email MFA'});
    }
    
    console.log(emailConfirm)
    if (!emailConfirm || emailConfirm.error) {
      toast.current.show({severity: 'error', summary: 'Enroll email error', detail: 'Failed to enroll email MFA'});
    } else {
      toast.current.show({life: 5000,severity: 'success', summary: 'Email mfa enroll', detail: 'Successfully enroll your email.'});
      publishService.sendAction('success');
    }
   
  };

  const enrollEmail = async () => {
    const data = {
      schemas: [
        "urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorEnroller",
      ],
      user: {
        value: userId,
      },
      authnFactors: ["EMAIL"],
    };
    var emailConfirm;
    try{
      emailConfirm = await _apiService.postEnrollMobile(data);
    }catch(err){
      toast.current.show({severity: 'error', summary: 'Enroll email error', detail: 'Request enroll email failed.'});
    }
    

    if (!emailConfirm || emailConfirm.error) {
      console.log("request failed");
    } else {
      setShowSubmit(true)
      setDeviceId(emailConfirm.deviceId)
      setRequestId(emailConfirm.requestId)
      
      window.setTimeout(() => {
        requestEmailPasscode(emailConfirm.deviceId,emailConfirm.requestId);
      }, 1500);
    }
   
  };

  const requestEmailPasscode = async (deviceId,requestId) => {
    const data = {
      schemas: [
        "urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorInitiator",
      ],
      deviceId: deviceId,
      requestId: requestId,
      userName: userName,
      authFactor: "EMAIL",
    };
    console.log('request email pass code datat : ',data)

    var requsetResult;

    try{
    requsetResult = await _apiService.postRequestPassMobile(data);
    toast.current.show({life: 5000,severity: 'success', summary: 'Request email otp code', detail: 'Successfully request email otp code.'});
    }catch(err){
      toast.current.show({severity: 'error', summary: 'Request email otp code', detail: 'Request email otp code failed.'});
    }
   
  };

  const validateEmailPasscode = async (otpCode,deviceId,requestId) => {
    const data = {
      schemas: [
        "urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorValidator",
      ],
      deviceId: deviceId,
      requestId: requestId,
      otpCode: otpCode,
      authFactor: "EMAIL",
      scenario: "ENROLLMENT",
    };

    var validateConfirm;
    try{
      validateConfirm = await  _apiService.postValidatePassMobile(data);
    }catch(err){
      toast.current.show({severity: 'error', summary: 'Verify email opt error', detail: 'Request verify email otp failed.'});
    }
    if (!validateConfirm || validateConfirm.error) {
      console.log("request failed");
  
    } else {
      // this.setState({
      //   showConfigEmail: false,
      //   emailIsEnabled: true,
      //   successConfirmMsg: "Your email has been configured.",
      // });
      //this.onShowAlert("sucessConfirmMsgAlert");
      toast.current.show({life: 5000, severity: 'success', summary: 'Email Enrolled', detail: 'Your email has been configured.'});
      publishService.sendAction('success');
    }
  };



  const updateEmailDefault = () => {
    updateDeviceDefault(EMAIL_TYPE, id);
  };

  const removeMfaEmail = () => {
    deviceRemoved(id, 'Your Email has been removed.');
  };

  return (
    <div className="grid grid-nogutter">
      <Toast ref={toast} />
      <div className="edit-cursor" onClick={()=>{
        if(emailExpand){
          return
        }
        handleEmailExpand()
      }}>
      <div className={`${emailExpand ? 'col-12' : 'col-8 md:col-4'} flex align-items-center justify-content-between`}>
        <p className="font-semibold">EMAIL {mfaStatus === EMAIL_TYPE && emailIsEnabled &&
        <Tag className="ml-2" severity="success" value="Default MFA"/>}
        </p>
      </div>
      <div className={`${emailExpand ? 'col-12' : 'col-4'} hidden md:flex align-items-center justify-content-start`}>
        {emailExpand ? null : (
          <div>
            <span>{emailIsEnabled ? email : 'Setup verification codes via email'}</span>
          </div>
        )}
      </div>
      </div>
      <div className={`flex align-items-center justify-content-end`}>
        {emailExpand ? null : (
          <>
            <Button
              onClick={() => {handleEmailExpand()}}
              label="Edit"
              className="hidden md:flex p-button-info p-button-text font-semibold"
            />
            <Button
              onClick={() => handleEmailExpand()}
              icon="pi pi-angle-right"
              className="p-button-rounded p-button-info text-4xl p-button-text text-900"
              aria-label="Email"
            />
          </>
        )}
      </div>
      <div className={`col-12 flex md:hidden align-items-center justify-content-start`}>
        {emailExpand ? null : (
          <div>
            <span>{emailIsEnabled ? email : 'Setup verification codes via email'}</span>
          </div>
        )}
      </div>

      {emailExpand && (
        !emailIsEnabled ? (
        <div className="w-full">
          <div className="my-2 font-semibold">
            {!primaryEmail ? ( 
            <div>
            {/* Sorry, no primary email address on file. Please contact Help Desk. */}
            <div className="w-full">
            <div className="field flex flex-column align-items-center md:align-items-start">
              <label htmlFor="email">Update Email Address</label>
              <div className="relative">
              <InputText
                  value={newEmailAddress}
                  placeholder="Enter New Email Address"
                  onChange={(e) => setNewEmailAddress(e.target.value)}
                />
                {newEmailAddress.match(emailAddressRegex) ? (
                  <i className="pi pi-check bg-green-500 p-1 border-circle text-white ml-2 mfa-icon"/>
                ) : (
                  ''
                )}
              </div>
              <div className="mt-2">
                <Password
                  className={`${invalidPassword ? "invalid-password" : ""} "mfa-password-input`}
                  placeholder='Enter password'
                  value={acctPassword}
                  onChange={(e) => {
                    setAccountPassword(e.target.value)
                    setInvalidPassword(false)
                  }}
                  toggleMask
                  feedback={false}
                />
              </div>
              <small className="p-error block">{message}</small>
            </div>
            <div className="flex justify-content-end">
              <Button onClick={() => {
                handleEmailExpand()
                setOtpCode("")
                setShowSubmit(false)
                setShowUpdateEmail(false)
                setInvalidPassword(false)
                }} label="Cancel" className="p-button-info p-button-text"/>
              <Button onClick={() => handleUpdateEmail()} label="Save" className="p-button-info ml-3"/>
            </div>
          </div>
            </div>
            ) : (
            <div>
              {primaryEmail}
            </div>
            )}
          </div>
          {primaryEmail && 
          <>
          <div className="my-2">
            {!showUpdateEmail ? <div>
             We found an email address on file. Would you like to enable this for 2-step verification?
            </div>:null}
            {showSubmit?<div className="otp-input-text"><InputMask
                  value={otpCode||''}
                  mask="999999"
                  slotChar=''
                  type='tel'
                  placeholder="Enter OTP code"
                  onChange={(e) => {
                    setInvalidOtp(false)
                    if(e.value){
                    setOtpCode(e.value.trim())
                    }
                    if(e.value===""){
                      setOtpCode(null)
                    }
                  
                  }}
                />
                {invalidOtp ? <small className="p-error block" style={{marginTop:'4px'}}>OTP code is required</small> : null}
                </div>
                
            :null}
            
            {!showUpdateEmail ?  ( !showSubmit ? <span className="margin-btn-top">
                <Button onClick={() => {
                  setShowUpdateEmail(true)
              }} label="Update"
                        className="p-button-info p-button-text font-bold px-0"/>&nbsp;&nbsp;&nbsp;&nbsp;
              </span>:null):<div>
              <div className="w-full">
            <div className="field flex flex-column align-items-center md:align-items-start">
              <label htmlFor="email">Update Email Address</label>
              <div className="relative">
              <InputText
                  value={newEmailAddress}
                  placeholder="Enter New Email Address"
                  onChange={(e) => setNewEmailAddress(e.target.value)}
                />
                {newEmailAddress.match(emailAddressRegex) ? (
                  <i className="pi pi-check bg-green-500 p-1 border-circle text-white ml-2 mfa-icon"/>
                ) : (
                  ''
                )}
              </div>
              <div className="mt-2">
                <Password
                  className={`${invalidPassword ? "invalid-password" : ""} "mfa-password-input`}
                  placeholder='Enter password'
                  value={acctPassword}
                  onChange={(e) => {
                    setAccountPassword(e.target.value)
                    setInvalidPassword(false)
                  }}
                  toggleMask
                  feedback={false}
                />
              </div>
              <small className="p-error block">{message}</small>
            </div>
            <div className="flex justify-content-end">
              <Button onClick={() => {
                handleEmailExpand()
                setShowSubmit(false)
                setShowUpdateEmail(false)
                setInvalidPassword(false)
              }} label="Cancel" className="p-button-info p-button-text"/>
              <Button onClick={() => handleUpdateEmail()} label="Save" className="p-button-info ml-3"/>
            </div>
          </div>
                
                </div>
            }

            { !showUpdateEmail ? (!showSubmit ? 
            //null :
            <span className="margin-btn-top">
                 <Button onClick={() => {
                  enrollEmailWithoutOptCode()
                  //enrollEmail()
              }} label="Enable"
                        className="p-button-info p-button-text font-bold px-0"/>
              </span>:
            <div className="margin-btn-top">
              <Button onClick={() => {
                setOtpCode(null)
                setInvalidOtp(false)
                requestEmailPasscode(deviceId,requestId)
                
              }} label="Resend"
                        className="p-button-info p-button-text font-bold px-0"/>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button onClick={() => {
                if(otpCode&&otpCode!==''&&deviceId&&requestId){
                  validateEmailPasscode(otpCode,deviceId,requestId)
                }else{
                  if((!otpCode)||otpCode===''){
                      setInvalidOtp(true)
                  }
              }

              }} label="Verify"
                        className="p-button-info p-button-text font-bold px-0"/>
              </div>):null}


              

              
              {showSubmit ? <div className="flex justify-content-end">
              <Button onClick={() => {
              
                handleEmailExpand()
                setOtpCode("")
                setShowSubmit(false)
                setShowUpdateEmail(false)
                setInvalidPassword(false)
                }} label="Cancel" className="p-button-info p-button-text"/>
              </div>:null}
          </div>
          </>
          }
          {/* <div className="flex justify-content-end">
            <Button onClick={() => handleEmailExpand()} label="Cancel" className="p-button-info p-button-text"/>
          </div> */}
        </div>
        ) : (
          <div className="w-full">
            <div className="my-2">
              {email}
            </div>
            <div className="my-2">
              {mfaStatus !== EMAIL_TYPE &&
              <>
                <div>
                  <Button onClick={() => updateEmailDefault()} label="Set as default verification method"
                          className="p-button-info p-button-text font-bold px-0"/>
                </div>
              </>
              }
            </div>
            <div className="field flex flex-column align-items-center md:align-items-start">
              <label htmlFor="email">Update Email Address</label>
              <div className="relative">
              <InputText
                  value={newEmailAddress}
                  placeholder="Enter New Email Address"
                  onChange={(e) => setNewEmailAddress(e.target.value)}
                />
                {newEmailAddress.match(emailAddressRegex) ? (
                  <i className="pi pi-check bg-green-500 p-1 border-circle text-white ml-2 mfa-icon"/>
                ) : (
                  ''
                )}
              </div>
              <div className="mt-2">
                <Password
                  className={`${invalidPassword ? "invalid-password" : ""} "mfa-password-input`}
                  placeholder='Enter password'
                  value={acctPassword}
                  onChange={(e) => {
                    setAccountPassword(e.target.value)
                    setInvalidPassword(false)
                  }}
                  toggleMask
                  feedback={false}
                />
              </div>
              <small className="p-error block">{message}</small>
            </div>
            <div className="flex justify-content-end">
              <Button onClick={() => {
                handleEmailExpand()
                setOtpCode("")
                setShowSubmit(false)
                setShowUpdateEmail(false)
                setInvalidPassword(false)
                }} label="Cancel" className="p-button-info p-button-text"/>
              <Button onClick={() => handleUpdateEmail()} label="Save" className="p-button-info ml-3"/>
            </div>
          </div>
        )
      )}
      <Divider/>
    </div>
  );
};

export default MFAEmail;
